import { render, staticRenderFns } from "./GlobalDashboardTableChart.vue?vue&type=template&id=f2b07e8a&scoped=true&"
import script from "./GlobalDashboardTableChart.vue?vue&type=script&lang=js&"
export * from "./GlobalDashboardTableChart.vue?vue&type=script&lang=js&"
import style0 from "./GlobalDashboardTableChart.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GlobalDashboardTableChart.vue?vue&type=style&index=1&id=f2b07e8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b07e8a",
  null
  
)

export default component.exports